// extracted by mini-css-extract-plugin
export default {"link":"bA-z","disabled":"cA-z"};